import { Box, Button, Typography, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startValidatePurchaseOrder } from '../../Redux/Slice/commonSlice'
import PurchaseOrderTable from './PurchaseOrderTable'
import InventoryNotesBox from './InventoryNotesBox'
import AnimatedResultScreen from './AnimatedResultScreen'

const InventoryApproval = () => {
    const [showRejectReason, setShowRejectReason] = useState(false)

    const dispatch = useDispatch()
    const purchaseOrder = useSelector(state => state.common?.purchaseOrder)
    const isLoading = useSelector(state => state.common?.purchaseOrderLoading)
    const successMessage = useSelector(state => state.common?.purchaseOrderSuccess)
    const errorMessage = useSelector(state => state.common?.purchaseOrderError)
    const actionType = useSelector(state => state.common?.purchaseOrderActionType)
    const approverId = useSelector(state => state.common?.approverId)
    const approvalCode = useSelector(state => state.common?.approvalCode?.value)

    const handleApprove = () => {
        // Hide reject reason box if it was shown
        setShowRejectReason(false)

        const body = {
            actionType: 'approved',
            cancellationReason: '',
            approverId: approverId,
            approvalCode: approvalCode
        }

        dispatch(startValidatePurchaseOrder({
            purchaseOrderId: purchaseOrder?._id,
            buildingId: purchaseOrder?.building,
            body
        }))
    }

    const handleReject = () => {
        setShowRejectReason(true)
    }

    const company = useSelector(state => state.common?.company)

    // Show result screen separately if there's a success or error message
    if (successMessage || errorMessage) {
        return (
            <Box sx={{
                height: "90vh",
                width: { xs: '300px', sm: '450px', md: '600px' },
                display: "flex",
                flexDirection: "column",
                border: { md: "0.5px solid grey" },
                borderRadius: { md: "10px" },
            }}>
                <Box sx={{
                    height: "10vh",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center', pt: 4
                }}>
                    <img
                        src={company?.logo}
                        alt="company_logo"
                        style={{ height: '45px' }}
                    />
                </Box>
                <Box sx={{
                    height: '60vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <AnimatedResultScreen
                        type={successMessage ? (actionType === 'approved' ? 'success' : 'rejected') : 'rejected'}
                        message={successMessage || errorMessage}
                    />
                </Box>
            </Box>
        )
    }

    return (
        <Box sx={{
            height: "88vh",
            width: { xs: '300px', sm: '450px', md: '600px' },
            display: "flex",
            flexDirection: "column",
            border: { md: "0.5px solid grey" },
            borderRadius: { md: "10px" },
        }}>
            <Box sx={{
                height: "10vh",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center', pt: 4
            }}>
                <img
                    src={company?.logo}
                    alt="company_logo"
                    style={{ height: '45px' }}
                />
            </Box>
            <Box sx={{
                height: '90vh',
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <Box>
                    <PurchaseOrderTable />
                </Box>
                {purchaseOrder?.status !== 'pending_approval' ? (
                    <Box sx={{ mt: 5 }}>
                        <Typography sx={{ fontSize: { xs: '15px', sm: '25px', md: '25px' } }}>This Purchase Order is {typeof purchaseOrder?.status === 'string' ? purchaseOrder.status.replace(/_/g, ' ') : purchaseOrder?.status}.</Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: "center" }}>
                        <Box sx={{ mt: { xs: 3, sm: 3, md: 3 }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: "center" }}>
                            <Box>
                                <Typography align={'center'} variant='h6'>Do you accept this purchase order?</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-around', pt: 2 }}>
                                <Button
                                    sx={{
                                        width: 100,
                                        bgcolor: '#F46326',
                                        color: '#fff',
                                        textTransform: 'none',
                                        ":hover": {
                                            bgcolor: '#dc4d28'
                                        },
                                    }}
                                    onClick={handleApprove}
                                    disabled={isLoading}
                                    startIcon={isLoading && !showRejectReason ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : null}
                                >
                                    {isLoading && !showRejectReason ? 'Processing...' : 'Yes'}
                                </Button>
                                <Button
                                    sx={{
                                        width: 100,
                                        bgcolor: '#F46326',
                                        color: '#fff',
                                        textTransform: 'none',
                                        ":hover": {
                                            bgcolor: '#dc4d28'
                                        },
                                    }}
                                    onClick={handleReject}
                                    disabled={isLoading}
                                >
                                    No
                                </Button>
                            </Box>
                        </Box>
                        <Box sx={{ width: { xs: '300px', sm: '800px', md: "800px" }, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 4 }}>
                            {showRejectReason && <InventoryNotesBox />}
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default InventoryApproval
